import 'trix'
import '@rails/actiontext'

// Add concern-link button to the trix toolbar
document.addEventListener('trix-initialize', function (event) {
  const toolbar = event.target.toolbarElement

  if (!toolbar.querySelector('[data-trix-attribute="concernLink"]')) {
    // Try different button groups in order of preference
    const groups = [
      '.trix-button-group--text-tools',
      '.trix-button-group--block-tools',
      '.trix-button-group'
    ]

    let group = null
    for (const groupSelector of groups) {
      group = toolbar.querySelector(groupSelector)
      if (group) {
        break
      }
    }

    if (group) {
      group.insertAdjacentHTML(
        'beforeend',
        `<button
                type="button"
                class="trix-button trix-button--icon"
                data-trix-attribute="concernLink"
                title="Concern Link"
                tabindex="-1"
                aria-label="Concern Link"
                >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <!--!Font Awesome Pro v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.-->
                  <path d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM248 320C234.7 320 224 330.7 224 344C224 357.3 234.7 368 248 368L392 368C405.3 368 416 357.3 416 344C416 330.7 405.3 320 392 320L248 320zM248 416C234.7 416 224 426.7 224 440C224 453.3 234.7 464 248 464L392 464C405.3 464 416 453.3 416 440C416 426.7 405.3 416 392 416L248 416z"/>
                </svg>
                </button>`
      )

      // Add click handler for the concern link button
      const concernButton = toolbar.querySelector(
        '[data-trix-attribute="concernLink"]'
      )
      if (concernButton) {
        concernButton.addEventListener('click', function (clickEvent) {
          clickEvent.preventDefault()

          // Find the trix-editor element and get its editor
          const trixEditor = event.target // This is the trix-editor element from the initialize event
          const editor = trixEditor.editor

          if (editor) {
            const selection = editor.getSelectedRange()

            if (selection && selection[0] !== selection[1]) {
              // Get the selected text for the modal
              const selectedText = editor.getSelectedDocument().toString()

              // Show concern selection modal
              showConcernSelectionModal(selectedText, (concernId) => {
                // Callback when concern is selected
                const jurisdictionId = getJurisdictionIdFromUrl()
                const concernUrl = `/jurisdictions/${jurisdictionId}/concerns?concern_id=${concernId}`

                // Apply the href attribute using Trix's built-in link system
                editor.activateAttribute('href', concernUrl)
              })
            }
          }
        })
      }
    }
  }
})

// Function to show concern selection modal
async function showConcernSelectionModal(selectedText, onConcernSelected) {
  try {
    // Get the current jurisdiction ID from the URL
    const jurisdictionId = getJurisdictionIdFromUrl()

    if (!jurisdictionId) {
      return
    }

    // Fetch published concerns for this jurisdiction
    const response = await fetch(
      `/admin/jurisdictions/${jurisdictionId}/concerns.json`
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch concerns: ${response.status}`)
    }

    const concerns = await response.json()

    const publishedConcerns = concerns.filter(
      (concern) => concern.status === 'Published'
    )

    if (publishedConcerns.length === 0) {
      alert('No published concerns found for this jurisdiction.')
      return
    }

    // Create and show the modal
    createConcernSelectionModal(
      selectedText,
      publishedConcerns,
      onConcernSelected
    )
  } catch (error) {
    alert('Failed to load concerns. Please try again.')
  }
}

function getJurisdictionIdFromUrl() {
  // Extract jurisdiction ID from current URL
  const match = window.location.pathname.match(/\/admin\/jurisdictions\/(\d+)/)
  return match ? match[1] : null
}

function createConcernSelectionModal(
  selectedText,
  concerns,
  onConcernSelected
) {
  // Create modal backdrop
  const modal = document.createElement('div')
  modal.className =
    'fixed inset-0 bg-black/50 flex items-center justify-center z-50'

  // Create concern options HTML
  const concernOptions = concerns
    .map((concern) => `<option value="${concern.id}">${concern.name}</option>`)
    .join('')

  modal.innerHTML = `
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
      <div class="p-6">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-gray-900">Link to Concern</h3>
          <button class="text-gray-400 hover:text-gray-600" onclick="this.closest('.fixed').remove()">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div class="mb-4">
          <p class="text-sm text-gray-600 mb-2">Selected text:</p>
          <div class="bg-gray-50 rounded-md p-3 text-sm font-medium text-gray-900 border">
            "${selectedText}"
          </div>
        </div>
        
        <div class="mb-6">
          <label for="concern-select" class="block text-sm font-medium text-gray-700 mb-2">
            Select a concern to link to:
          </label>
          <select id="concern-select" class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500">
            <option value="">Choose a concern...</option>
            ${concernOptions}
          </select>
        </div>
        
        <div class="flex justify-end space-x-3">
          <button class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200" onclick="this.closest('.fixed').remove()">
            Cancel
          </button>
          <button id="confirm-concern-link" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed" disabled>
            Create Link
          </button>
        </div>
      </div>
    </div>
  `

  document.body.appendChild(modal)

  // Handle concern selection
  const select = modal.querySelector('#concern-select')
  const confirmButton = modal.querySelector('#confirm-concern-link')

  select.addEventListener('change', () => {
    confirmButton.disabled = !select.value
  })

  confirmButton.addEventListener('click', () => {
    const concernId = select.value
    if (concernId) {
      onConcernSelected(concernId)
      modal.remove()
    }
  })

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.remove()
    }
  })
}
